module.exports = __webpack_public_path__ + "static/media/download (1) 1 (2).81d29d69.svg";